import { log as pilog } from "@limitless/common/utils";
export const TASK_TYPE_LABEL = {
  respondNew: {
    label: "New"
  },
  respondSticky: {
    label: "My Assigned Task"
  },
  respond: {
    label: "Respond"
  },
  respondExisting: {
    label: "Respond"
  },
  review: {
    label: "Peer Review"
  },
  reviewFee: {
    label: "Peer Review"
  },
  reviewDetailed: {
    label: "Quality Review"
  },
  reviewQuality: {
    label: "Quality Review"
  },
  reviewEscalation: {
    label: "Forward Review"
  }
};
export const calculateFilteredMessages = (tasklist, filters, isStickyThresholdReached = false, profile) => {
  const log = pilog.getLogger("TaskListHelper");
  log.debug(filters);
  log.debug(tasklist);
  let activeFilterCount = 0;
  let unreadStickyCount = 0;
  let stickyMessageCount = 0;
  const {
    passedTasks,
    taskType,
    selectedGroups,
    selectedFilters,
    taskFee,
    passed
  } = filters;
  const group1Filters = [];
  const groupTenantFilters = [];
  const feeFilter = [];
  let isPassed = false;
  if (selectedFilters.length > 0) {
    var _Object$entries;
    (_Object$entries = Object.entries(selectedFilters)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(([filterKey, value]) => {
      if (value.filtertType === "tasktype") {
        const filter = taskType[value.id];
        group1Filters.push(filter);
      }
      if ("groupName" in value) {
        groupTenantFilters.push(value);
      }
      if (value.name === "Fee") {
        feeFilter.push(value === null || value === void 0 ? void 0 : value.label.split("-"));
      }
      if ("passed" in value) {
        isPassed = value.passed;
      }
    });
  }
  activeFilterCount = group1Filters.length;
  if (selectedGroups.value.length !== 0) {
    activeFilterCount += 1;
  }
  if ((taskFee === null || taskFee === void 0 ? void 0 : taskFee.minFee) > 0 || (taskFee === null || taskFee === void 0 ? void 0 : taskFee.maxFee) > 0) {
    activeFilterCount += 1;
  }
  if (passedTasks.pass.value) {
    activeFilterCount += 1;
  }
  let filteredMessages = {};
  Object.keys(tasklist).map(messageId => {
    const messageInbox = tasklist[messageId];
    let meetsFilters = false;
    if (group1Filters.length !== 0) {
      meetsFilters = group1Filters.some(filterType => filterType.filter(messageInbox, filterType.value));
    } else {
      //if there are no active group1 filters, it meets the criteria
      meetsFilters = true;
    }
    if (passedTasks.pass.value) {
      meetsFilters = passedTasks.pass.filter(messageInbox) && meetsFilters;
    }
    if (!passedTasks.pass.value) {
      meetsFilters = !passedTasks.pass.filter(messageInbox) && meetsFilters;
    }
    if (groupTenantFilters.length !== 0) {
      meetsFilters = selectedGroups.filter(messageInbox, groupTenantFilters) && meetsFilters;
    }
    if (feeFilter.length !== 0) {
      meetsFilters = (messageInbox === null || messageInbox === void 0 ? void 0 : messageInbox.rewardFee) >= (taskFee === null || taskFee === void 0 ? void 0 : taskFee.minFee) && (messageInbox === null || messageInbox === void 0 ? void 0 : messageInbox.rewardFee) <= (taskFee === null || taskFee === void 0 ? void 0 : taskFee.maxFee);
    }
    // Apply expert location restrictions:
    // - If the expert is tenant-secure location, only include messages from matched tenants.
    if ((profile === null || profile === void 0 ? void 0 : profile.expertTrustedLocationType) === "tenant") {
      meetsFilters = (profile === null || profile === void 0 ? void 0 : profile.matchedTenants.includes(messageInbox.tenantName)) && meetsFilters;
    }
    // - If the expert has no location restriction, include only messages without an expertTrustedLocation.
    if ((profile === null || profile === void 0 ? void 0 : profile.expertTrustedLocationType) === "none") {
      meetsFilters = !messageInbox.expertTrustedLocation && meetsFilters;
    }
    if (meetsFilters) {
      filteredMessages[messageId] = messageInbox;
    }
    if (messageInbox.type === "respondSticky" && messageInbox.new) {
      unreadStickyCount++;
    }
    if (messageInbox.type === "respondSticky") {
      // Include respondSticky messages in the filteredMessages object
      filteredMessages[messageId] = messageInbox;
      stickyMessageCount++;
    }
    if (isStickyThresholdReached) {
      const filteredStickyMessages = Object.fromEntries(Object.entries(filteredMessages).filter(([_, msg]) => msg.type === "respondSticky"));

      // Assign filteredStickyMessages back to filteredMessages to ensure only sticky messages remain
      filteredMessages = filteredStickyMessages;
    }
  });
  log.debug(filteredMessages);
  return {
    filteredMessages,
    activeFilterCount,
    unreadStickyCount,
    stickyMessageCount
  };
};
export const validateTaskFeeFilter = taskFee => {
  const fieldErrors = {};
  if (taskFee.maxFee && !Number.isInteger(taskFee.maxFee) || taskFee.minFee && !Number.isInteger(taskFee.minFee)) {
    fieldErrors.text = "Fee must be numerical";
  } else if (isNaN(taskFee.maxFee.toString()) || isNaN(taskFee.minFee.toString())) {
    fieldErrors.text = "Fee must be numerical";
  } else if (taskFee.maxFee >= 0 && taskFee.maxFee < taskFee.minFee) {
    fieldErrors.text = "Max must be higher than min";
  }
  const isFormInvalid = Object.keys(fieldErrors).length === 0 ? false : true;
  return {
    fieldErrors,
    isFormInvalid
  };
};